class Dropdown {
    constructor() {
        this.handlers = {
            dropdownSelector: "[data-dropdown]",
            dropdownTriggerSelector: "[data-dropdown-trigger]",
            dropdownContentSelector: "[data-dropdown-content]",
            dropdownTrigger: [],
            dropdownContent: [],
        };
        this.config = {
            activeClass: 'is-open',
            mobileStyleAttribute: 'data-dropdown-style-mobile',
            mobileStyleWidth: '1024px',
            overlayClass: 'overlay-active'

        };
        this.isAnyOpen = false;
        this.init();
    }

    init() {
        this.handlers.dropdownTrigger = document.querySelectorAll(this.handlers.dropdownTriggerSelector);
        if (!this.handlers.dropdownTrigger.length) return false;

        this.handlers.dropdownContent = document.querySelectorAll(this.handlers.dropdownContentSelector);
        if (!this.handlers.dropdownContent.length) return false;

        this.initEvents();
    }

    assignHandlers() {
        if (!this.handlers.current) return;

        this.handlers.dropdown = this.handlers.current.closest(this.handlers.dropdownSelector);

        if (this.handlers.dropdown) {
            this.handlers.content = this.handlers.dropdown.querySelector(this.handlers.dropdownContentSelector);
        }
    }

    toggleOverlayLayer() {
        if (this.handlers.dropdown.getAttribute(this.config.mobileStyleAttribute) === "" &&
            window.matchMedia(`(max-width:${this.config.mobileStyleWidth})`).matches) {
            document.body.classList.toggle(this.config.overlayClass);
        } else {
            document.body.classList.remove(this.config.overlayClass);
        }
    }

    toggleDropdown() {
        if (this.handlers.content) {
            this.handlers.content.classList.toggle(this.config.activeClass);
            this.toggleOverlayLayer();
            this.isAnyOpen = !this.isAnyOpen;
        }
    }

    closeOthersInstances() {
        this.handlers.dropdownContent.forEach(dropdownContent => {
            if (dropdownContent !== this.handlers.content) {
                dropdownContent.classList.remove(this.config.activeClass);
            }
        });
    }

    closeAllInstances() {
        this.handlers.dropdownContent.forEach(dropdownContent => {
            dropdownContent.classList.remove(this.config.activeClass);
        });
        if (this.isAnyOpen) this.toggleOverlayLayer();
        this.isAnyOpen = false
    }

    initEvents() {
        const _self = this;
        this.handlers.dropdownTrigger.forEach(triggerDropdown => {
            triggerDropdown.addEventListener('click', function(e) {
                _self.handlers.current = this;
                _self.assignHandlers();
                _self.closeOthersInstances();
                _self.toggleDropdown();
            });
        });

        document.addEventListener('click', e => {
            if (!e.target.closest('[data-dropdown]')) {
                this.assignHandlers();
                this.closeAllInstances();
            }
        });
    }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/assets/js/common/Dropdown.js